var Partials = {/*
    partialName: "partialString"
*/}

export default Partials
